import React, { useMemo } from 'react';

import PropTypes from 'prop-types';

import { CustomRadiobutton } from 'components/CustomRadiobutton/CustomRadiobutton';
import { InfoTooltip } from 'components/InfoTooltip/InfoTooltip';

import './LabelRadiobutton.sass';

export const LabelRadiobutton = ({
  label,
  id,
  value,
  onChange,
  disabled,
  icon,
  isEdited,
  name,
  tooltipText,
  error,
  checked,
}) => {
  const getClassnameForError = useMemo(() => {
    if (error) return 'error';
    return '';
  }, [error]);

  return (
    <div className="label-radiobutton">
      <CustomRadiobutton
        id={name + label}
        value={value}
        onChange={onChange}
        disabled={disabled}
        name={name}
        isEdited={isEdited}
        tooltipText={tooltipText}
        error={error}
        checked={checked}
      />
      {icon && <img src={icon} alt="label-radiobutton-icon" />}
      {label && (
        <label id={id} className={getClassnameForError} htmlFor={name + label}>
          {label}
        </label>
      )}
      {tooltipText && <InfoTooltip title={tooltipText} />}
    </div>
  );
};

LabelRadiobutton.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
  label: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  isEdited: PropTypes.bool,
  name: PropTypes.string.isRequired,
  tooltipText: PropTypes.string,
  error: PropTypes.bool,
};

LabelRadiobutton.defaultProps = {
  label: '',
  icon: '',
  tooltipText: '',
  error: false,
  disabled: false,
  isEdited: false,
};
